import { useQuery } from '@tanstack/react-query';
import { fetchSigners } from 'app/shared/digital-signature/digital-signature.service';

export const fetchSignersQuery = (entity: string, idEntity: number) => {
  return useQuery({
    queryKey: ['signersList', entity, { idEntity: idEntity }],
    queryFn: () => fetchSigners(entity, idEntity),
  });
};
